export default __webpack_public_path__ + "cc98214c30537e75067ccac03c9a524a.png";